/* eslint-disable no-trailing-spaces */
module.exports = {
    main: {
        "source": 99,
        "terminalId": 1,
        "site_id": 33, // partner id
        "slug": 1,
        "hasDayFilter": false,
        "staffPassword": "",
        "disableRemoteConfig": true,
        //"honeyBadgerKey": "da413f18"  //hardcoded
        "prematchDayFilterValue": [1, 2, 3, 4],
        "prematchDayFiltersCount": 0,
        "useBetBookLastApi": false,
        "restrictedAdminPrintableTicketsCount": 5,
        "cashoutCommissionPercent": 4,
        "preloadPromotions": true,
        "resultPageVirtualsId": [150, 197, 209, 118, 54, 55, 31, 184, 181],
        "showItfStatistics": true,
        "useBrowserHistory": true, //use browser history instead of hash history (in IE8, IE9 and older browsers page will be reloaded on navigation)
        "authSessionLifeTime": 2628000, // time to store login (in seconds)
        "authSessionLessLifeTime": 1800, // time to store login (in seconds)
        "rfidPinCode": null, // null, required, or optional
        "disableFreeBet": false,
        "subscribeToCashdesk": false,
        "hasBetSlipEventsLimit": 16,
        "legacyActions": ["register", "login", "reset_password", "verify"],
        "keepPopupsAfterLocationChange": false,
        "liveGamesCountInHomePage": 5,
        "commaSeparator": false,
        "termsAndConditionPDFLoad": false,
        // ef3a1ffa-5405-4fa4-8fd1-4fdf81b17d6f
        "testString": "SwarmTestPrivateKey",
        "popupForTerminalLock": false,
        "balanceLimit": 10000000000,
        "useLoyalCardBarcode": false,
        "loyalCardRemoveIcon": false,
        "showBalanceIcon": false,
        "euroPaymentIdes": [87], // time to store login (in seconds)
        "betslipAdditionalMessages": {
            "insufficientBalance": {
                "link": "/balance/deposit",
                "linkTarget": "_self",
                "message": "Insufficient balance",
                "postFix": "Deposit"
            }
        },
        "popularGameId": [1, 3, 4],
        "availableLanguages": {
            'eng': {
                'short': 'EN',
                'full': "English",
                order: 1
            },
            'spa': {
                'short': 'ES',
                'full': "Español",
                order: 2
            },
            'arm': {
                'short': 'HY',
                'full': "Հայերեն",
                order: 4
            },
            'rus': {
                'short': 'RU',
                'full': "Русский",
                order: 3
            },
            'por': {
                'short': 'PT',
                'full': "Português",
                order: 5
            },
            'tur': {
                'short': 'TR',
                'full': "Türkçe",
                order: 6
            },
            'kor': {
                'short': 'KO',
                'full': "한국어",
                order: 7
            },
            'jpn': {
                'short': 'JP',
                'full': "日本語",
                order: 8
            },
            'chi': {
                'short': 'CH',
                'full': "繁体中文",
                order: 9
            },
            'geo': {
                'short': 'KA',
                'full': "ქართული",
                order: 10
            },
            'swe': {
                'short': 'SE',
                'full': "Swedish",
                order: 11
            },
            'ger': {
                'short': 'DE',
                'full': "Deutsch",
                order: 12
            },
            'nor': {
                'short': 'NO',
                'full': "Norwegian",
                order: 13
            }
        },
        "mapLanguages": {
            "uae": "AE",
            "heb": "HE"
        },
        "liveChat": null,
        "enableBetCoLucky": false,
        "enableAppearGame": false,
        "showRegionsListInLiveMode": true,
        "enableLoyaltyPoints": false,
        "enabelFromGameToMarkets": false,
        "customTags": [], //generate additional tags for skins use this format [{tag: "tagName", [prop1: 'prop1', prop2: 'prop2'...]}],
        "favoriteCompetitionRegion": true,
        "enableFunctionalitySetMousePosition": true,
        "disableTitoBet": false,
        "enableCoeficenFullValueView": false,
        "disableCashoutBet": false,
        "disableTitoCashout": false,
        "disableTitoLottery": false,
        "disableKeyboardBarcodeCatch": false, //old name disableBarcodeDetection
        "popularGamesCount": 4,
        "popularGamesViewCount": 0,
        "popularGamesWithCompCount": 4,
        "secondPopularGamesCount": 6,
        
        "languageSelectorMode": "select", // "select" or "list"
        "availableCurrencies": ['USD', 'EUR', 'RUB', 'UAH', 'CNY', 'KZT', 'PLN', 'SEK', 'MXN'],
        //"defaultCurrencyRounding": 2, //obsolete
        "currencyRounding": 2, //number of decimal places to round displayed amounts (used if cannot be found in config loaded from swarm)
        "amountFixedDecimalCount": false,
        "availableOddFormats": ['decimal', 'fractional', 'american', 'hongkong', 'malay', 'indo'],
        "useLadderForFractionalFormat": true, // use "ladder" when displaying odds in fractional format
        "roundDecimalCoefficients": 2,
        "coefficientsDecimalZeroFill": true, // rounding of coefficients, number of significant digits
        "showPointsInsteadCurrencyName": false, //replace all currency names with "PTS"
        "mainMenuItemsOrder": ["prematch", "live", "casino", "live-casino"],
        "gamesAuthorizationUrl": "/authorization.php",
        "termsAndConditionsDefaultLanguage": "eng",
        "statsHostname": {
            // "prefixUrls": 'https://statistics.betconstruct.com/#/',
            "prefixUrl": 'https://statistics.betconstruct.com/#/',
            "defaultLang": 'en',
            "subUrl": '/external/page/'
        },
        "personalDetails": {
            "readOnlyFields": ['id', 'username', 'first_name', 'last_name', 'birth_date', 'gender', 'email', 'doc_number'],
            "editableFields": ['country_code', 'city', 'phone', 'bank_info', 'password', 'address'],
            "requiredFields": ['country_code', 'city', 'phone', 'password'],
            "bankInfoMask": '99999999999'
        },
        "video": {
            "enableLiveGamesFilter": true,
            //availableVideoProviderIds: [1, 3, 5, 6, 16, 19, 25], //list of available providers
            "enabled": true,
            "autoPlay": true,
            "useHlsUrlFromResponse": false, //only for topSport skin
            "evenIfNotLoggedIn": false
        },
        "usePartnerStreams": true,
        "bonus": {
            "disableBonusCanceling": false
        },
        "esportsGames": ['Dota', 'Dota2', 'CounterStrike', 'LeagueOfLegends', 'StarCraft', 'StarCraft2', 'Hearthstone', 'CallofDuty', 'Overwatch', 'HeroesOfTheStorm'],
        "teamLogosPath": 'https://statistics.betconstruct.com/images/',
        "geoipLink": "https://geoapi.betcoapps.com/",
        "minimalPasswordLength": 6,
        "userDepositLimits": {
            "enabled": false
        },
        "userBetLimits": {
            "enabled": false
        },
        "selfExclusionByExcType": 2, // config values are   false, "1", "2"
        "casinoStartDateFormat": "YYYY-MM-DT00:00:01",
        "casinoEndDateFormat": "YYYY-MM-DT23:59:59",
        "dateFormat": "ddd, D MMM YYYY", // momentJS display format string
        "asianDateFormat": "ddd D", // momentJS display format string
        "timeFormat": "HH:mm", // momentJS display format string
        "dateTimeFormat": "ddd, D MMM YYYY, HH:mm", // momentJS display format string
        "shortDateTimeFormat": "ddd HH:mm", // momentJS display format string
        "prematchTimeFilterValues": [3, 6, 12, 24, 48, 72], // hours (above sports list in prematch)
        "prematchWidgetTimeFilterValues": [5, 10, 15, 30], // mins (dashboard)
        "animationDisplayTime": 180, // seconds since event start to display animation
        "regConfig": {
            "settings": {
                "minYearOld": 18,
                "maxYearOld": 100,
                "defaultCountry": null, //iso standard
                "loginAfterRegistration": true,
                "sendEmailAsUsername": false,
                "dateFormat": "YYYY-MM-DD",
                "restrictedCountries": [], //["AU"] iso standard
                "disablePhoneValidation": false
            }
        },
        "balanceHistoryMainSelectableTypes": ["0", "1", "3", "9", "10", "12", "14", "15", "16", "50", "83", "84", "301", "302"],
        "balanceHistoryCasinoSelectableTypes": [0, 1, 2, 3, 4, 5, 6],

        "payments": [],
        "paymentByCurrency": false,
        "disableMultipleSingleBets": true,
        "currency": {
            'USD': '$',
            'EUR': '€',
            'TTD': 'TT$',
            'AMD': 'Դ ',
            'GEL': '₾',
            'GBP': '£',
            'PEN': 'S/.',
            'RUB': '₽',
            'TRY': '₺',
            'BRL': 'R$',
            'COP': '$',
            'CAD': '$',
            'IDR': 'Rp',
            'DOP': 'RD$',
            'CFA': 'CFA ',
            'TND': 'TND ',
            'RON': 'RON ',
            'MXN': 'MXN ',
            'PLN': 'PLN ',
            'SEK': 'SEK ',
            'ZAR': 'ZAR '
        }
    },
    "counterOfferTimer": 30,
    "taxPercentOnStake": 0,
    "emptyEventLines": false,
    "systemOptionsOnFooter": false,
    "superBetAfterStakeInput": false,
    "eventsCountToShowBetslipClear": 1,
    "staticStakeInKeyboard": false,
    "betslipAcceptAndPlaceOneButton": false,
    "showPriceUpdateDirection": false,
    "hideMaxStake": false,
    "betslipClearAllButtonOnFooter": false,
    "hideRegionsListOnTopGames": false,
    "terminal": {
        "depositView": false,
        "asianViewEnabled": false,
        "scrollButtons": false,
        "printUserBet": false,
        "setGameListDropDown": false,
        "disableLiveGamesInToday": false,
        "scrollButtonsSearchAndPrintTickets": false,
        "enableSignOutWithRfidButton": false,
        "asianViewTwoImportantMarkets": false,
        "marketsForAsian": ["WINNER", "HANDICAP"],
        "sportsbookSettingsTypes": ["standart", "asian"],
        "disableTicket": false
    },
    "upper_screen": {
        "statistics_live": false,
        "statistics_prematch": true,
        "live_streaming": true,
        "live_animations": true
    },
    "homeLiveGamesCount": 16,
    "liveCasinoActiveGroup": {
        "Live Roulette": 1,
        "Live BlackJack": 2,
        "Live Baccarat": 3,
        "Live Poker": 4
    },
    "urlPrefix": "https://games.betconstruct.com/authorization.php?",
    "betting": {
        "bookingEnabledOnlyWithoutBalance": false,
        "bet_source": '99',
        "maxWinLimit": false,
        "enableChainBet": false,
        "disableMaxBet": false,
        "enableBetBuilder": false,
        "enableExpressBonus": false,
        "acceptOddDefaultType": 1, // 0 - Always ask, 1 - Accept higher odds, 2 - Accept any odds, 3 - Counter offer, -1 - Superbet
        "expressBonusVisibilityQty": 1,
        "boostedMinCountInBetslip": 0,
        "expressBonusType": 1, //1: regular bonus 2,3,4,5..% ; 2: 2-5,10,15,20,25,30,30..30 %; 3: (k > 2.5) ? 7% : 0;
        "enableSuperBet": false,
        "enableSuperBetAutomatically": false,
        "allowSuperBetForLive": false,
        "showSuperBetNotificationsViaPopup": false,
        "enableHorseRacingBetSlip": true, // SP, new bet types, etc.
        "enableEachWayBetting": false,
        "enableShowBetSettings": false,
        "allowManualSuperBet": false,
        "enableCounterOffer": false,
        // superBetCheckingIntervalTime: 5000,
        "showFinalPayout": false,
        "betAcceptedMessageTime": 5000,
        "showTotalWinWithoutBonus": false,
        "quickBetNotificationsTimeout": 4000,
        "autoSuperBetLimit": {}, // {'GEL': 400, 'AMD': 50000, 'USD': 1000} //if not false then set limit for each currency if stake is greater then Limit superbet is enabling automaticaly
        "resetAmountAfterBet": false,
        "totalOddsMax": 1000,
        "enableLimitExceededNotifications": false,
        "allowSuperBetOnLive": false,
        "enableBetterOddSelectingFunctyionality": false,
        "rememberAutoAcceptPriceChangeSettings": false,
        "enableBankerBet": false,
        "enableBookingBet": false,
        "quickBet": {
            "hideQuickBet": false,
            "enableQuickBetStakes": false,
            "visibleForPaths": ['sport', 'overview'],
            "quickBetStakeCoeffs": {
                'USD': 5,
                'AMD': 50,
                'EUR': 3
            },
            "quickBetStakeBases": [1, 2, 5, 10],
            "quickBetBaseMultipliers": [1, 10, 100]
        },
        "disableClearAllInBetProgress": false,
        "disableMaxButtonInBetProgress": false,
        "allowBetWithoutLogin": true, // allow to click "place bet" without logging in. will get corresponding error message from backend and open login form
        "enablePartialCashOut": false
    },
    "betBuilder": {
        "url": "https://betconstruct-prod-gen2.sportcastlive.com/markets",
        "licenseKey": "a6aa080b-cea9-4e3f-aa02-9fef8d1f0c8f",
        "password": "ewmFb896vwmHeRFp",
        "oddsMap": {
            "decimal": "DecimalPrice",
            "american": "AmericanPrice",
            "fractional": "FractionalPrice",
            "hongkong": "HongKongPrice",
            "indo": "IndoPrice",
            "malay": "MalayPrice"
        },
        "languageMap": {
            "eng": "en-GB",
            "spa": "es-ES",
            "arm": "hy-AM",
            "rus": "ru-RU",
            "por": "pt-PT",
            "tur": "tr-TR",
            "fra": "fr-FR",
            "rum": "ro-RO"
        },
    },
    "partner": {},
    "rfid": {
        "logoutIfIdleSecondsCount": null,
    },
    "swarm": {
        "debugging": false, //enable websocket debugging
        "languageMap": {
            "pol": "eng",
            "por": "por_2",
            "pt-br": "por",
            "fre": "fra",
            "chi": "zho",
            "mac": "mkd",
            "bgr": "bul",
            "lat": "lav",
            "fas": "far",
            "rum": "ron",
            "ro": "ron",
            "dut": "nld",
            "hrv": "srp"
        },
        "sendSourceInRequestSession": true,
        "sendTerminalIdlInRequestSession": false,
        "webSocketTimeout": 5000,
        "url": [{
            "url": "https://eu-swarm-lp.betconstruct.com/"
        }],
        "websocket": [{
            "url": "wss://mrg-swarm-betshops-ws.betconstruct.com/"
            //"url": "wss://swarm-staging.betconstruct.com"//staging swarm url
        }],
        "useWebSocket": true,
        "maxWebsocketRetries": 100, // maximum number of websocket reconnect attempts after which it will give up
        "webSocketRetryInterval": 2000 // retry interval, in milliseconds (will be increased after each unsuccessful retry by itself)
    },
    "jackpot": {
        "webSocketTimeout": 5000,
        "websocket": "wss://rgs-wss.betconstructapps.com/jackpot",
        "maxWebsocketRetries": 100, // maximum number of websocket reconnect attempts after which it will give up
        "webSocketRetryInterval": 2000 // retry interval, in milliseconds (will be increased after each unsuccessful retry by itself)
    },
    "regionShortNames": {
        "World": "WORLD",
        "Americas": "AME",
        "Angola": "AGO",
        "Europe": "EUROPE",
        "Asia": "ASIA",
        "Africa": "AFRICA",
        "Albania": "ALB",
        "Azerbaijan": "AZE",
        "South America": "SAM",
        "Algeria": "DZA",
        "Andorra": "AND",
        "Argentina": "ARG",
        "Aruba": "ABW",
        "Armenia": "ARM",
        "Australia": "AUS",
        "Austria": "AUT",
        "Belarus": "BLR",
        "Belgium": "BEL",
        "Bolivia": "BOL",
        "Brazil": "BRA",
        "Bulgaria": "BGR",
        "Burkina Faso": "BFA",
        "Canada": "CAN",
        "China": "CHN",
        "Chinese Taipei": "TWN",
        "Czech Republic": "CZE",
        "Chile": "CHL",
        "Colombia": "COL",
        "Côte d'Ivoire": "CIV",
        "Costa Rica": "CRI",
        "Croatia": "HRV",
        "Cyber Matches": "CBR",
        "Lesotho": "LSO",
        "Cuba": "CUB",
        "Denmark": "DNK",
        "Estonia": "EST",
        "Finland": "FIN",
        "France": "FRA",
        "Germany": "DEU",
        "Greece": "GRC",
        "Great Britain": "GRB",
        "Guatemala": "GTM",
        "Honduras": "HND",
        "Hong Kong": "HKG",
        "Hungary": "HUN",
        "Iceland": "ISL",
        "Ireland": "IRL",
        "Israel": "ISR",
        "Italy": "ITA",
        "India": "IND",
        "Iran": "IRN",
        "Japan": "JPN",
        "Jordan": "JOR",
        "South Korea": "PRK",
        "Kuwait": "KWT",
        "Kenya": "KEN",
        "Kosovo": "UNK",
        "Latvia": "LVA",
        "Liberia": "LBR",
        "Lithuania": "LTU",
        "Macedonia": "MKD",
        "Malaysia": "MYS",
        "Mexico": "MEX",
        "Montenegro": "MNE",
        "Morocco": "MAR",
        "Netherlands": "NLD",
        "Norway": "NOR",
        "North America": "NAM",
        "New Zealand": "NZL",
        "Nicaragua": "NIC",
        "Nigeria": "NGA",
        "Oman": "OMN",
        "Oceania": "OCEANIA",
        "Palestine": "PSE",
        "Peru": "PER",
        "Poland": "POL",
        "Portugal": "PRT",
        "Paraguay": "PRY",
        "Philippines": "PHL",
        "Romania": "ROU",
        "Russia": "RUS",
        "Singapore": "SGP",
        "Samoa": "WSM",
        "Slovenia": "SVN",
        "South Africa": "ZAF",
        "Spain": "ESP",
        "Sweden": "SWE",
        "Sudan": "SDN",
        "SRL Matches": "SRL",
        "Switzerland": "CHE",
        "United Republic of Tanzania": "TZA",
        "TrinidadTobago": "TTO",
        "Thailand": "THA",
        "Turkey": "TUR",
        "Tunisia": "TUN",
        "UAE": "UAE",
        "Ukraine": "UKR",
        "United Kingdom": "GBR",
        "USA": "USA",
        "Uruguay": "URY",
        "Uzbekistan": "UZB",
        "Venezuela": "VEN",
        "Vietnam": "VNM",
        "America": "AME",
        "England": "ENG",
        "Northern Ireland": "NIRL",
        "Qatar": "QAT",
        "Saudi Arabia": "SAU",
        "Serbia": "SRB",
        "Slovakia": "SVK",
        "Scotland": "SCO",
        "Wales": "WLS",
        "Zimbabwe": "ZWE",
        "Bahrain": "BHR",
        "Barbados": "BRB",
        "Burundi": "BDI",
        "BosniaHerzegovina": "BIH",
        "Cyprus": "CYP",
        "Ecuador": "ECU",
        "Egypt": "EGY",
        "Mauritania": "MRT",
        "Georgia": "GEO",
        "Indonesia": "IDN",
        "Jamaica": "JAM",
        "Kazakhstan": "KAZ",
        "Malta": "MLT",
        "Tajikistan": "TJK",
        "Uganda": "UGA",
        "Zambia": "ZMB",
        "El Salvador": " SLV",
        "Mozambique": "MOZ",
        "Dominican Republic": "DOM",
        "Senegal": "SEN",
        "Brunei Darussalam": "BRN",
        "Namibia": "NAM",
        "Panama": "PAN",
        "Bangladesh": "BGD",
        "Togo": "TGO",
        "Sri Lanka": "LKA",
        "Ethiopia": "ETH",
        "Lebanon": "LBN",
        "Pakistan": "PAK",
        "Rwanda": "RWA",
        "Syria": "SYR",
        "Cameroon": "CMR",
        "San Marino": "SMR",
        "FYR Macedonia": "MKD",
        "Malawi": "MWI",
        "Botswana": "BWA",
        "Djibouti": "DJI",
        "Gibraltar": "GIB",
        "Mali": "MLI",
        "Moldova": "MDA",
        "Belize": "BLZ",
        "Myanmar": "MMR",
        "Saint Kitts and Nevis": "KNA",
        "Macau": "MAC",
        "Cote d'Ivoire": "CIV",
        "Andorra ": "AND",
        "Antigua and Barbuda": "ATG",
        "Haiti ": "HTI",
        "Gambia ": "GMB",
        "Mauritania ": "MRT",
        "Faroe Islands": "FRO",
        "Iraq": "IRQ",
        "Cambodia": "KHM",
        "Puerto Rico": "PRI",
        "Mongolia": "MNG",
        "Bhutan": "BTN",
        "Lao People's Democratic Republic": "LAO",
        "Fiji": "FJI",
        "North Macedonia": "MKD",
        "Luxembourg": "LUX",
        "DR Congo": "COD",
        "Benin": "BEN",
        "Nepal": "NPL",
        "Gambia": "GMB",
        "New Caledonia": "NCL",
        "Ghana": "GHA",
        "Kyrgyzstan": "KGZ"
    },
    "casino": {
        "defaultFilteredProvider": [],
        "casinoBlockedProviders": [],
        "providersThatWorkWithSwarm": [],
        "enableMultipleProviderSelect": false,
        "urlPrefix": false,
        "gamesUrl": '/global/mplay1.php',
        "url": "https://www.cmsbetconstruct.com/casino",
        "middlewareUrl": "https://betshop-rgs-api.betcoapps.com",
        "middlewareAuthToken": "A4d822sU4R47E0z4XCf57OkFJbfiaZbW",
        "disableCasinoPlayForFunMode": false,
        "allProviders": {
            "showAll": true
        },
        "allCategories": {
            "showAll": true
        },
        "games": {
            "loaderStep": 21
        }
    },
    "tournaments": {
        "firstLoadStep": 10,
        "loaderStep": 2,
        "filtersData": [
            {
                "name": 'Statuses',
                "field": 'state',
                "filters": [
                    { "name": 'Upcoming', "value": 3, "active": true },
                    { "name": 'Live', "value": 2, "active": true },
                    { "name": 'Finished', "value": 1 },
                    { "name": 'Canceled', "value": -1 }
                ]
            },
            {
                "name": 'Registration statuses',
                "field": 'registrationStatus',
                "filters": [
                    { "name": 'Registration Started', "value": 1, "active": true },
                    { "name": 'Registration Finished', "value": 2 }
                ]
            },
            {
                "name": 'Entry types',
                "field": 'buyInStatus',
                "filters": [
                    { "name": 'Buy-in', "value": 1 },
                    { "name": 'Free Entry', "value": 2, "active": true }
                ]
            }
        ]
    },
    "liveCasino": {
        "liveCasinoBlockedProviders": [],
        "helpUrl": "https://websitelivegames-am.betconstruct.com/Home/HelpInfo",
        "clv": false,
        "drg": false,
        "games": {
            "loaderStep": 21
        }
    },
    // default values, that can be changed by user
    "env": {
        "lang": "eng",
        "oddsFormat": "decimal"
    },
    "geoLocationOddFormatSwitcher": {
        "enabled": false,
        "default": "decimal",
        "IE": "fractional",
        "GB": "fractional",
        "US": "american",
        "HK": "hongkong",
        "ID": "indo",
        "MY": "malay"
    },
    "disableCasinoAndSportsBonusesToShow": false,
    "disableNavMenuFromLeftMenu": false,
    "adminWideLotteryPopups": false,
    "adminPageButtons": [
        {
            name: 'Admin User',
            type: 'adminUserSections',
            hideOnRestrictMode: true,
            enabled: false
        },
        {
            name: "Application And Terminal Management",
            type: "applicationAndTerminal",
            enabled: true
        },
        {
            name: "Tickets",
            type: "lastTicket",
            enabled: true
        },
        {
            name: "Financial Tracking",
            type: "financialTracking",
            enabled: true
        },
        {
            name: "Open last log file",
            type: 'openLastLogFile',
            enabled: true
        },
        {
            name: "Lock",
            type: "lockAndUnlock",
            param: { type: "lock" },
            enabled: true
        },
        {
            name: "Unlock",
            type: "lockAndUnlock",
            param: { type: "unlock" },
            enabled: true
        },
        {
            name: "Devices",
            type: "devices",
            enabled: true
        }
    ],
    "applicationAndTerminalButtons": [
        {
            name: 'Shut down terminal',
            hideOnRestrictMode: false
        },
        {
            name: 'Close application',
            hideOnRestrictMode: false
        },
        {
            name: 'Reboot PC',
            hideOnRestrictMode: false
        }
    ],
    "lotteryTicketsCountOnRestrictedMode": 0,
    "deviceManagementButtons": [
        "Reset bill acceptor",
        "Reset Device Connections",
        "Status"
        //"Check Hoppers errors and states"
    ],
    "financialButtons": [
        "Last entered bills and coins",
        "Stacker Balance",
        "Todays Report",
        "Encashment"
    ],
    "lastTicketButtons": [
        {
            name: 'Show last tickets',
            type: 'printLastTicket',
            hideOnRestrictMode: false
        },
        {
            name: 'Print last cash out ticket',
            type: 'printLastCashoutTicket',
            hideOnRestrictMode: false
        },
        {
            name: 'Print last bet ticket',
            type: 'printLastBetTicket',
            hideOnRestrictMode: false
        }
        //"Show lottery last tickets",
        // "Print tickets paid by this terminal",
    ],
    "interfaceVersion": "1.0.0",
    "enableFavoritesGame": false,
    "asianMarketTypeFilter": {
        "HANDICAP": {
            "Soccer": ["HalfTimeAsianHandicap", "2ndHalfAsianHandicap", "AsianHandicap"]
        },
        "TOTALS": {
            "Soccer": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"]
        }
    },
    "textsPopupAfterActions": {
        "Cashout": "Thanks for your participation! Redeem your balance , please visit cashier.",
        "CashoutBet": "Thanks for your participation! Redeem your balance , please visit cashier.",
        "EarlyCashoutSucceed": "Your bet has been Cashed Out successfully!"
    },
    "messages": {
        "disableMessages": true
    },
    "enableStandardGameListDateGrouping": true,
    "enableHeaderSectionName": false,
    "cashoutTitle": "Would you like to cashout",
    "enableRefreshButton": false,
    "ticketCheckBetSlip": false,
    "homePageView": 4,
    "searchInHeader": false,
    "betslipExpandableIcon": false,
    "showGameNumber": false,
    "enableBetslipLiveIcon": false,
    "enableBaseDropDown": false,
    "selectMarketTypeInDropdown": ["HANDICAP", "TOTALS"],
    "animatinAndChartEnabled": true,
    "enableCashoutbyTicketandCash": false,
    "homePageCompetitionsCount": 4,
    "betTypesInOneLine": false,
    "enableSliderForBetone": false,
    "enableTimeFilterInPrintTicket": false,
    "enableUpcomingLiveGamesInPrematch": false,
    "homePageHorseRacing": false,
    "enablePrintLastBetTicketKeycode": false,
    "defaultTerminalParams": { pid: 33, tid: 992, token: "bnBzAA==", currency: 'EUR' },
    //"defaultTerminalParams": { pid: 33, tid: 76, token: "z2IdAA==", currency: 'EUR' },//staging default params
    "useCurrencySymbol": true,
    "diableEsportsFromPrematchSection": false,
    "staticStake": false,
    "enableBoostedOdds": false,
    "enableMultiplesForPrematch": false,
    "enablePredefinedMultiples": false,
    "sportListThatCanBeBoostedOdds": ["Soccer", "Tennis", "Handball"],
    "enableOrderInBetslip": false,
    "favoriteCompetitionsScroll": false,
    "enableHomeImageSlider": false,
    "enableDayFormatInPrematchLeftMenu": false,
    "enableOneDayRangeFilterPrematch": false,
    "runtimeOddsFormatDropdow": false,
    "SecureSwarmConnectionWithHash": true, 
    "TaxInParts": false,
    "swapTaxAndBonus": false,
    "maxGameLoadCountToSelectRegion": 250,
    "enableScrollInHomePageUSA": false,
    "usaSportCompetitionConfig": [],
    "enableUsaSortByDate": false,
    "enableUSABetslipType": false,
    "enableCasinoFavorites": false,
    "popularSportsGameCount": false,
    "popularSportsShowCurrentActive": false,
    "matchOfTheDayMarkets": [],
    "enableMultipleDaysReport": false,
    "enableAsianMarketSideView": true,
    "enablePopularSportIcons": false,
    "diableBetPayForOtherBetshops": false,
    "staticStakeCounts": { default: [0.2, 0.5, 1, 2] },
    "clearStakeInputOnKeyboardOpen": false,
    "enableCopyBetButton": false,
    "urlForDualScreenStatistics": "https://statistics.betconstruct.com/#/",
    "enableTouchPositionIniFrames": false,
    "ticketBasedGameIds": ["112001", "112002", "112004", "112005"],
    "marketsNofitication": [],
    "virtualsEnablePopup": false,
    "betslipTextsCircus": false,
    "oldTicketsRestriction": false,
    "minWinAmountToHandleIdentitionPopup" : 30,
    "enableLogoOnPopups": false,
    "nextRacingEnabled": false,
    "estimatedReturnAndTotalWinCalculationChange": false,
    "enableCurrencyView": true,
    "enableDepositMoney": false,
    "removeOutright": false,
    "nextLotteryEnabled": false,
    "splitScreen": false,
    "splitScreenUrl": "https://bettingterminalupperscreen.betconstruct.com",
    "betNeedConfirmation": false,
    "dmsTicketInEnable": false,
    "enableMultipleWinsPopup": false,
    "multipleWinsMaxTicketsCount": 15,
    "refreshButtonDisabledTime": 0,
    "disableBalanceInHeader": false,
    "disableCashoutInHeader": false,
    "disablePlaceBetButton": false,
    "repeatBetInterval": null,
    "enableRepeatBetButton": false,
    "enablePeriodScore": false,
    "popupForTerminalInactivity": false,
    "statisticsButton": false,
    "enableTodayButtonOnSport": false,
    "showBalanceInCashoutMenu": false,
    "enableMarketCountInBetSlip": false,
    "ticketPopupRemoveCounterSeconds": 10,
    "AdminShortcutWithLoginOnly": false,
    "scrollButtonsSearchAndPrintLotteryTickets": false,
    "availableOdds": [
        {
            "odds": 'american',
            "title": "American",
            "enabled": true
        },
        {
            "odds": 'decimal',
            "title": "Decimal",
            "enabled": true
        },
        {
            "odds": 'malay',
            "title": "Malaya",
            "enabled": false
        },
        {
            "odds": 'indo',
            "title": "Indo",
            "enabled": false
        },
        {
            "odds": 'hongkong',
            "title": "Hongkong",
            "enabled": false
        },
        {
            "odds": 'fractional',
            "title": "Fractional",
            "enabled": false
        }
    ],
    'asianViewMarket': {
        'Soccer': {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    },
                    {
                        "display_key": "DOUBLE CHANCE",
                        "title": "DOUBLE CHANCE",
                        "side": ["1X", "12", "X2"]
                    },
                    {
                        "display_key": "NEXTGOALTOSCORE",
                        "title": "NEXT GOAL TO SCORE",
                        "side": ["Home", "No", "Away"]
                    }
                ],
                [
                    {
                        "display_key": "BOTHTEAMTOSCORE",
                        "title": "Both Team To Score",
                        "side": ["Yes", "No"]
                    },
                    {
                        "display_key": "DRAWNOBET",
                        "title": "Draw No Bet",
                        "side": ["Team1", "Team2"]
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 1.5",
                        "side": ["Over", "Under"],
                        "base": 1.5
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 2.5",
                        "side": ["Over", "Under"],
                        "base": 2.5
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 3.5",
                        "side": ["Over", "Under"],
                        "base": 3.5
                    },
                    // {
                    //     "display_key": "TOTALS",
                    //     "market_type": { "@in": ["OverUnderAsian", "HalfTimeOverUnderAsian", "2ndHalfTotalOver/UnderAsian"] },
                    //     "title": "Total Goals Asian",
                    //     "side": ["Over", "Under"]
                    // },
                    {
                        "display_key": "ODD/EVEN",
                        "market_type": { "@in": ["EvenOddTotal", "FirstHalfEvenOddTotal", "SecondHalfEvenOddTotal"] },

                        "title": "Total Goals: Even/Odd",
                        "side": ["Even", "Odd"]
                    },
                    {
                        "display_key": "HANDICAP",
                        "market_type": { "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"] },
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2, 3, 4] }
                    },
                    // {
                    //     "display_key": "HANDICAP",
                    //     "market_type": { "@in": ["AsianHandicapAsian", "HalfTimeAsianHandicapAsian", "2ndHalfAsianHandicapAsian"] },
                    //     "title": "Asian Handicap",
                    //     "side": ["Home", "Away"],
                    //     "main_order": { "@in": [1, 2] }
                    // },
                    {
                        "display_key": "CARDSTOTALS",
                        "title": "Yellow Cards: Total",
                        "side": ["Over", "Under"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    },
                    {
                        "display_key": "DOUBLE CHANCE",
                        "title": "DOUBLE CHANCE",
                        "side": ["1X", "12", "X2"]
                    }
                ], [
                    {
                        "display_key": "BOTHTEAMTOSCORE",
                        "title": "Both Team To Score",
                        "side": ["Yes", "No"]
                    },
                    {
                        "display_key": "DRAWNOBET",
                        "title": "Draw No Bet",
                        "side": ["Team1", "Team2"]
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 1.5",
                        "side": ["Over", "Under"],
                        "base": 1.5
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 2.5",
                        "side": ["Over", "Under"],
                        "base": 2.5
                    },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"] },
                        "title": "Total Goals 3.5",
                        "side": ["Over", "Under"],
                        "base": 3.5
                    },
                    // {
                    //     "display_key": "TOTALS",
                    //     "market_type": { "@in": ["OverUnderAsian", "HalfTimeOverUnderAsian", "2ndHalfTotalOver/UnderAsian"] },
                    //     "title": "Total Goals Asian",
                    //     "side": ["Over", "Under"]
                    // },
                    // {
                    //     "display_key": "ODD/EVEN",
                    //     "market_type": { "@in": ["EvenOddTotal", "FirstHalfEvenOddTotal", "SecondHalfEvenOddTotal"] }, 
                    //     "title": "Total Goals: Even/Odd",
                    //     "side": ["Even", "Odd"]
                    // },
                    {
                        "display_key": "HANDICAP",
                        "market_type": { "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"] },
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2, 3, 4] }
                        //"base": { "@in": [0.5, 1.5, 2.5, 3.5] }   //todo: check why not working like this
                    },
                    // {
                    //     "display_key": "HANDICAP",
                    //     "market_type": { "@in": ["AsianHandicapAsian", "HalfTimeAsianHandicapAsian", "2ndHalfAsianHandicapAsian"] },
                    //     "title": "Asian Handicap",
                    //     "side": ["Home", "Away"],
                    //     "main_order": { "@in": [1, 2] }
                    // },
                    {
                        "display_key": "CARDSTOTALS",
                        "title": "Yellow Cards: Total",
                        "side": ["Over", "Under"]
                    }
                ]
            ]
        },
        "Tennis": {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "P2"]
                    },
                    {
                        "market_type": "SetHandicap",
                        "title": "Set Handicap",
                        "side": ["Home", "Away"]
                    }
                ], [
                    // {
                    //     "market_type": { "@in": ["TotalofMatchPoints", "SetTotalPoints"] },
                    //     "title": "Total Points",
                    //     "side": ["Over", "Under"]
                    // },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["SetOverUnder", "TotalGamesOver/Under"] },
                        "title": "Total Games",
                        "side": ["Over", "Under"]
                    },
                    {
                        "market_type": { "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"] },
                        "title": "Total Games Odd or Even",
                        "side": ["Even", "Odd"]
                    }
                    //todo: we need following markets
                    //{X} Set {Y} Game Winner market  
                    //{X} Set {Y} Game Handicap Points
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "P2"]
                    },
                    {
                        "market_type": "SetHandicap",
                        "title": "Set Handicap",
                        "side": ["Home", "Away"]
                    }
                ], [
                    // {
                    //     "market_type": { "@in": ["TotalofMatchPoints", "SetTotalPoints"] },
                    //     "title": "Total Points",
                    //     "side": ["Over", "Under"]
                    // },
                    {
                        "display_key": "TOTALS",
                        "market_type": { "@in": ["SetOverUnder", "TotalGamesOver/Under"] },
                        "title": "Total Games",
                        "side": ["Over", "Under"]
                    },
                    {
                        "market_type": { "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"] },
                        "title": "Total Games Odd or Even",
                        "side": ["Even", "Odd"]
                    }
                ]
            ]
        },
        "Basketball": {
            "live": [
                [
                    {
                        "market_type": { "@in": ["MatchWinner3", "QuarterWinner3", "HalfWinner3"] },
                        "title": "Winner 3 way",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ], [
                    {
                        "display_key": "WINNER",
                        "title": "Winner 2 Way",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }, {
                        "title": "Overtime",
                        "market_type": "Overtime",
                        "side": ["P1", "P2"]
                    }, {
                        "display_key": "HANDICAP",
                        "title": "Match Handicap",
                        "side": ["Home", "Away"]
                    }, {
                        "display_key": "TOTALS",
                        "title": "Match Total",
                        "side": ["Over", "Under"]
                    }, {
                        "display_key": "ODD/EVEN",
                        "title": "Match Total Odd/Even",
                        "side": ["Even", "Odd"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "market_type": { "@in": ["MatchWinner3", "QuarterWinner3", "HalfWinner3"] },
                        "title": "Winner 3 Way",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ], [
                    {
                        "display_key": "WINNER",
                        "title": "Winner 2 Way",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }, {
                        "title": "Overtime",
                        "market_type": "Overtime",
                        "side": ["P1", "P2"]
                    }, {
                        "display_key": "HANDICAP",
                        "title": "Match Handicap",
                        "side": ["Home", "Away"]
                    }, {
                        "display_key": "TOTALS",
                        "title": "Match Total",
                        "side": ["Over", "Under"]
                    }, {
                        "display_key": "ODD/EVEN",
                        "title": "Match Total Odd/Even",
                        "side": ["Even", "Odd"]
                    }
                ]
            ]
        },
        "IceHockey": {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "Winner (Regular Time)",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    },
                    {
                        "display_key": "DOUBLE CHANCE",
                        "title": "Double chance (Regular Time)",
                        "side": ["1X", "12", "X2"]
                    },
                    {
                        "market_type": { "@in": ["MatchTotal3", "PeriodTotal3"] }, // there is no PeriodTotal3, leave for the future
                        "display_key": "TOTALS",
                        "title": "Total 3 Way (Regular Time)",
                        "side": ["Over", "Exactly", "Under"]
                    },
                    {
                        "market_type": "NextTeamToScore",       //todo: check this market when games are live
                        "title": "Next Team to Score",
                        "side": ["Home", "Away", "No"]
                    }
                ], [
                    {
                        "display_key": "WINNER",
                        "title": "Winner (With Overtime)",
                        "market_type": "MatchWinner2",
                        "side": ["P1", "P2"]
                    },
                    {
                        "display_key": "BOTHTEAMTOSCORE",
                        "title": "Both Team To Score",
                        "side": ["Yes", "No"]
                    },
                    {
                        "market_type": { "@in": ["MatchTotal2", "PeriodTotal2"] },
                        "display_key": "TOTALS",
                        "title": "Total (Regular Time)",
                        "side": ["Over", "Under"]
                    },
                    // {
                    //     "market_type": { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
                    //     "display_key": "TOTALS",
                    //     "title": "Asian Total (Regular Time)",
                    //     "side": ["Over", "Under"]
                    // }, 
                    {
                        "market_type": { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
                        "display_key": "HANDICAP",
                        "title": "Handicap (Regular Time)",
                        "side": ["Home", "Away"]
                    }
                    // {
                    //     "market_type": { "@in": ["MatchHandicap2Asian", "PeriodHandicap2Asian"] },
                    //     "display_key": "HANDICAP",
                    //     "title": "Asian Handicap (Regular Time)",
                    //     "side": ["Home", "Away"]
                    // }
                    //odd even apush market Khcoi asac chenq drel
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "Winner (Regular Time)",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    },
                    {
                        "display_key": "DOUBLE CHANCE",
                        "title": "Double chance (Regular Time)",
                        "side": ["1X", "12", "X2"]
                    },
                    {
                        "market_type": { "@in": ["MatchTotal3", "PeriodTotal3"] }, // there is no PeriodTotal3, leave for the future
                        "display_key": "TOTALS",
                        "title": "Total 3 Way (Regular Time)",
                        "side": ["Over", "Exactly", "Under"]
                    }
                ], [
                    {
                        "display_key": "WINNER",
                        "title": "Winner (With Overtime)",
                        "market_type": "MatchWinner2",
                        "side": ["P1", "P2"]
                    },
                    {
                        "display_key": "BOTHTEAMTOSCORE",
                        "title": "Both Team To Score",
                        "side": ["Yes", "No"]
                    },
                    {
                        "market_type": { "@in": ["MatchTotal2", "PeriodTotal2"] },
                        "display_key": "TOTALS",
                        "title": "Total (Regular Time)",
                        "side": ["Over", "Under"]
                    },
                    // {
                    //     "market_type": { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
                    //     "display_key": "TOTALS",
                    //     "title": "Asian Total (Regular Time)",
                    //     "side": ["Over", "Under"]
                    // }, 
                    {
                        "market_type": { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
                        "display_key": "HANDICAP",
                        "title": "Handicap (Regular Time)",
                        "side": ["Home", "Away"]
                    }
                    // {
                    //     "market_type": { "@in": ["MatchHandicap2Asian", "PeriodHandicap2Asian"] },
                    //     "display_key": "HANDICAP",
                    //     "title": "Asian Handicap (Regular Time)",
                    //     "side": ["Home", "Away"]
                    // }
                    //odd even apush market Khcoi asac chenq drel
                ]
            ]
        },
        "Volleyball": {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "Winner",
                        "side": ["P1", "P2"]
                    },
                    {
                        "market_type": "HANDICAP",       //todo: check this market when games are live
                        "title": "Match points Handicap",
                        "side": ["Home", "Away"]
                    }, {
                        "market_type": "TOTALS",       //todo: check this market when games are live
                        "title": "Total points",
                        "side": ["Home", "Away"]
                    }
                ], [

                    // {
                    //     "market_type": { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
                    //     "display_key": "TOTALS",
                    //     "title": "Asian Total (Regular Time)",
                    //     "side": ["Over", "Under"]
                    // }, 
                    {
                        "market_type": { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
                        "display_key": "HANDICAP",
                        "title": "Handicap (Regular Time)",
                        "side": ["Home", "Away"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "Winner",
                        "side": ["P1", "P2"]
                    },
                    {
                        "market_type": "HANDICAP",       //todo: check this market when games are live
                        "title": "Match points Handicap",
                        "side": ["Home", "Away"]
                    }, {
                        "market_type": "TOTALS",       //todo: check this market when games are live
                        "title": "Total points",
                        "side": ["Home", "Away"]
                    }
                ], [

                    // {
                    //     "market_type": { "@in": ["MatchTotal2Asian", "PeriodTotal2Asian"] },
                    //     "display_key": "TOTALS",
                    //     "title": "Asian Total (Regular Time)",
                    //     "side": ["Over", "Under"]
                    // }, 
                    {
                        "market_type": { "@in": ["MatchHandicap2", "PeriodHandicap2"] },
                        "display_key": "HANDICAP",
                        "title": "Handicap (Regular Time)",
                        "side": ["Home", "Away"]
                    }
                ]
            ]
        },
        'Pesapallo': {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "TOTALS",
                        "side": ["Over", "Under"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "TOTALS",
                        "side": ["Over", "Under"]
                    }
                ]
                 
            ]
        },
        'Handball': {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "Total Goals",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "HANDICAP",
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "title": "Total Goals",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "HANDICAP",
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                        //"base": { "@in": [0.5, 1.5, 2.5, 3.5] }   //todo: check why not working like this
                    },
                    {
                        "display_key": "WINNER",
                        "title": "Match result",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }
                ]
            ]
        },
        'BallHockey': {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "Match Result",
                        "side": ["P1", "X", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "Total Goals",
                        "side": ["Over", "Under"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "Match Result",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "title": "Total Goals",
                        "side": ["Over", "Under"]
                    }
                ]
            ]
        },
        'Futsal': {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "Total Goals",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "HANDICAP",
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "title": "Total Goals",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "HANDICAP",
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                        //"base": { "@in": [0.5, 1.5, 2.5, 3.5] }   //todo: check why not working like this
                    },
                    {
                        "display_key": "WINNER",
                        "title": "Match result",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }
                ]
            ]
        },
        'RugbyLeague': {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "Total Goals",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "HANDICAP",
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "title": "Total Goals",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "HANDICAP",
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                        //"base": { "@in": [0.5, 1.5, 2.5, 3.5] }   //todo: check why not working like this
                    },
                    {
                        "display_key": "WINNER",
                        "title": "Match result",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }
                ]
            ]
        },
        'RugbyUnion': {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "Total Goals",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "HANDICAP",
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "title": "Total Goals",
                        "side": ["Over", "Under"]
                    },
                    {
                        "display_key": "HANDICAP",
                        "title": "Handicap",
                        "side": ["Home", "Away"],
                        "main_order": { "@in": [1, 2] }
                        //"base": { "@in": [0.5, 1.5, 2.5, 3.5] }   //todo: check why not working like this
                    },
                    {
                        "display_key": "WINNER",
                        "title": "Match result",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }
                ]
            ]
        },
        'WaterPolo': {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "HANDICAP",
                        "title": "Handicap",
                        "side": ["Home", "Away"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ], [
                    {
                        "display_key": "HANDICAP",
                        "title": "Handicap",
                        "side": ["Home", "Away"]
                    }
                ]
            ]
        },
        "Darts": {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "market_type": "TotalSetsOver/Under",
                        "title": "TOTAL SETS",
                        "side": ["Over", "Under"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "market_type": "TotalSetsOver/Under",
                        "title": "TOTAL SETS",
                        "side": ["Over", "Under"]
                    }
                ]
            ]
        },
        'Chess': {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "side": ["P1", "X", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "TOTALS",
                        "side": ["Over", "Under"]
                    }
                ]
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 3,
                        "side": ["P1", "X", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "TOTALS",
                        "side": ["Over", "Under"]
                    }
                ]
            ]
        },
        "default": {
            "live": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }
                ],
                [
                    {
                        "display_key": "TOTALS",
                        "title": "TOTALS",
                        "side": ["Over", "Under"]
                    }
                ] 
            ],
            "prematch": [
                [
                    {
                        "display_key": "WINNER",
                        "title": "WINNER",
                        "col_count": 2,
                        "side": ["P1", "P2"]
                    }
                ], [
                    {
                        "display_key": "TOTALS",
                        "title": "TOTALS",
                        "side": ["Over", "Under"]
                    }
                ]
            ]
        }
    }
};
